import objectFitPolyfill from "object-fit-polyfill";

const Slider = () => {
	let speed = 5000;

	function showNextSlide(slides, /* current index*/i) {
		slides[i].classList.remove('active');
		i++

		if (i >= slides.length) {
			i = 0;
		}

		slides[i].classList.add('active');
		return i;
	}

	Array.from(document.querySelectorAll('.slider')).forEach(slider => {
		// values for each slider
		let i = 0;
		let slides = slider.querySelectorAll('.slider-item');

		setInterval(function() {
			requestAnimationFrame(function() {
				i = showNextSlide(slides, i);
			});
		}, speed);
	});
};

export default Slider;
